<template lang="html">
  <transition name="move">
    <div class="complete" v-show="showFlag" ref="complete">   
        <div class="titletext">
            <!-- 完成点餐 -->
            <h1><span class="icon icon-check_circle"></span>{{ $t("completeorder") }}</h1>
        </div>
        <div class="data">
            <!-- 取餐号 -->
            <div class="data-text">{{ $t("orderid") }}</div>
            <div class="data-index">{{complete.MiniOrderId}}</div>               
        </div>
        <div class="details">
            <div class="">
            <!-- 应付金额 -->
               <div class="details-l">{{ $t("amounts") }}</div>
               <div class="details-r"><span>{{complete.Total | numFilter}} €</span></div>
            </div>
            <div>
            <!-- 订单编号 -->
               <div class="details-l">{{ $t("ordersheet") }}</div>
               <div class="details-r">{{complete.Sheet}}</div>
            </div>               
        </div>
         <split></split>
          <div class="content-oneline" @click="hide">
            <div class="pay">
                {{ $t("backtomain") }}
          </div>
      </div>
    </div>
   
  </transition>
</template>
<script>
import split from 'components/split/split.vue'

export default {
  props: {
  },
  data() {
    return {
      showFlag: false,  // 默认complete组件是隐藏的
      complete: {  // complete由父组件传入
        type: Object
      },
      state: this.$store.state
    }
  },
  methods: {
    show(complete) {
      this.complete = complete
      this.showFlag = true  // 展示complete组件
    },
    hide() {
      this.showFlag = false
      // this.$parent.hide()
    }
  },
  components: {
    split
  },
  filters: {
    numFilter (value) {
      // cutOutNum(value)
      let realVal = ''
      if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2)
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  updated() {
    console.log(this.complete)
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.complete {
  position: fixed;
  left: 0;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  width: 100%;
  background: #fff;
  &.move-enter-active, &.move-leave-active { // 动画过程
    transition: all .5s;
    transform: translate3d(0,0,0);
  }
  &.move-enter, &.move-leave-to { // 动画初始态
    transform: translate3d(100%,0,0);
  }
  .titletext {
    background-color: #f5f3f7;
    h1{
        line-height: 80px;
        text-align: center;
        color: green;
     }
  } 
  .data{
      padding: 20px 0px;
      border-bottom: 2px solid #f5f3f7;
      .data-text{
          width: 100%;
          line-height: 45px;
          text-align: center;
      }
       .data-index{
          width: 100%;
          line-height: 30px;
          font-size: 40px;
          color: red;
          text-align: center;
      }
  }
  .details{
    width: 100%;
    height: 60px;
    margin: 10px 5px 30px 5px;
    .details-l{
        margin-left: 4px;
        width: 29%;
        float: left; 
        line-height:30px;       
    }
    .details-r{
        width: 66%;
        text-align: right;
        float: left;
        line-height:30px;
        span{
            color: red;
        }
    }
  }
    .content-oneline {
            flex: 0 0 105px;
            background: #00b43c;
            border-radius: 10px;
            margin: 20px;
            .pay {
                line-height: 48px;
                text-align: center;
                font-size: 14px;
                font-weight: 700;
                background: #00b43c;
                color: #fff;
            }
        }
}
</style>



// WEBPACK FOOTER //
// complete.vue?1fc29577